const angular = require('angular')
const ionic = require('ionic')
const IScroll = require('iscroll')

module.exports = angular.module('hxphone.infrastructure.contact', [])
/* 构造iScroll实例 */
  .directive('contactScroll', ['$timeout', function($timeout) {
    return {
      replace: false,
      restrict: 'A',
      link: function(scope, element, attr) {
        const touchmoveEvent = function(e) {
          e.preventDefault()
        }

        /**
         * 实例化iScroll方法
         */
        function initScroll() {
          // TODO:  没有使用，删除？
          scope.contactScroll = new IScroll(element[0], {
            hScroll: false,
            onBeforeScrollStart: function(e) {
              const exception = /^(INPUT|TEXTAREA|BUTTON|SELECT|A)$/i
              if (!exception.test(e.target.tagName)) {
                e.preventDefault()
              }
            }
          })
          document.addEventListener('touchmove', touchmoveEvent, false)
        }

        scope.$watch(attr.contactScroll, function() {
          $timeout(initScroll, 100)
        })

        /* --------------------------------暴露到父作用域的方法--------------------------------- */
        /**
         * 刷新iScroll
         * @param isRefresh
         */
        scope.$parent.refreshScroll = function(isRefresh) {
          isRefresh = typeof isRefresh === 'boolean' ? isRefresh : false
          if (isRefresh && scope.contactScroll) {
            $timeout(function() {
              scope.contactScroll.refresh()
            }, 0)
          }
        }

        /**
         * 销毁iScroll
         */
        scope.$parent.destroyScroll = function() {
          if (scope.contactScroll) {
            scope.contactScroll.destroy()
            scope.contactScroll = null
          }
          document.removeEventListener('touchmove', touchmoveEvent, false)
        }

        /**
         * 让iScroll生效
         */
        scope.$parent.enableScroll = function() {
          if (scope.contactScroll) {
            scope.contactScroll.enable()
          }
        }

        /**
         * 让iScroll失效
         */
        scope.$parent.disableScroll = function() {
          if (scope.contactScroll) {
            scope.contactScroll.disable()
          }
        }
      }
    }
  }])
  /* DOM是否准备好，只能应用在ng-repeat */
  /* 因为iScroll延时了100ms来实例化，当DOM渲染较快时，该指令其实没有什么用。如果DOM渲染很慢，iScroll已经实例化了，这个指令才会起到作用 */
  .directive('contactScrollReady', function() {
    return {
      replace: false,
      restrict: 'A',
      link: function(scope, element, attr) {
        scope.refreshScroll(scope.$last)
      }
    }
  })

  /* 搜索 */
  .directive('contactSearcher', ['$timeout', function($timeout) {
    return {
      replace: false,
      restrict: 'A',
      link: function(scope, element, attr) {
        const input = element.find('input')
        const overlay = element.next()
        overlay.css('height', document.body.clientHeight + 'px')

        function attachEvents(destroy) {
          const method = destroy ? 'off' : 'on'
          input[method]('focus', scope.contactSearcher.active)
          input[method]('keydown', keydown)
          input[method]('search', search)
          overlay[method]('click', overlayClick)
        }

        function detachEvents() { //eslint-disable-line
          attachEvents(true)
        }

        function keydown(evt) {
          if (evt.keyCode == 13) {
            scope.contactSearcher.inactive()
          }
        }

        /**
         * IOS下，在input中输入文字，虚拟键盘会先有"确认"，后有"换行"。
         * 我们需要在"换行"时触发操作，而不是"确认"。所以这里加了一个延时
         */
        function overlayClick() {
          $timeout(function() {
            scope.contactSearcher.inactive()
          }, 400)
        }

        function search() {
          const resetPage = element.data('search-cancel')
          const keyword = input.val().trim()
          if (resetPage) {
            scope.getAllPabContacts()
          } else if (keyword.length > 0) {
            scope.searchContacts(keyword)
          }
        }

        /* public methods */

        scope.contactSearcher = {}
        /**
         * input失去焦点
         * @param cancel
         *  分为以下几种情况：
         *      1、cancel为true，放弃搜索，回到页面初始状态
         *      2、cancel为false，关键字为空，回到页面初始状态
         *      2、cancel为false，关键字不为空，执行搜索
         */
        scope.contactSearcher.inactive = function(cancel) {
          cancel = typeof cancel === 'boolean' ? cancel : false
          scope.enableScroll()
          if (cancel || input.val().trim().length === 0) {
            input.val('')
            element.removeClass('active')
            overlay.removeClass('active')
            element.data('search-cancel', true)
          } else {
            overlay.removeClass('active')
            element.data('search-cancel', false)
          }
          input.triggerHandler('search')
          if (ionic.Platform.isIOS()) {
            $timeout(function() {
              input[0].blur()
            }, 400)
          } else {
            $timeout(function() {
              input[0].blur()
            }, 600)
          }
        }

        /**
         * input获得焦点，激活搜索
         */
        scope.contactSearcher.active = function() {
          scope.disableScroll()
          if (ionic.Platform.isIOS()) {
            $timeout(function() {
              element.hasClass('active') ? angular.noop() : element.addClass('active')
              overlay.hasClass('active') ? angular.noop() : overlay.addClass('active')
            }, 400)
          } else {
            element.hasClass('active') ? angular.noop() : element.addClass('active')
            overlay.hasClass('active') ? angular.noop() : overlay.addClass('active')
          }
        }

        // 绑定事件
        attachEvents()
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/infrastructure/contact.js